export interface PaginationRequestInterface {
  per: number
  page: number
}

interface PaginationMetaInterface extends PaginationRequestInterface {
  total: number
}

export class PaginationMeta implements PaginationMetaInterface {
  /** The total number of results */
  public page: number
  public per: number
  public total: number

  constructor(page = 0, per = 25, total = 0) {
    this.page = page
    this.per = per
    this.total = total
  }

  static fromResponse(metadata: PaginationMetaInterface): PaginationMeta {
    return new this(metadata.page, metadata.per, metadata.total)
  }

  public get vaporPage(): number {
    return this.page + 1
  }

  public get pageCount(): number {
    return Math.ceil(this.total / this.per)
  }
}

export interface PaginatedInterface<T> {
  items: T[]
  metadata: PaginationMeta
}

export class Paginated<T> implements PaginatedInterface<T> {
  public items: T[]
  public metadata: PaginationMeta

  constructor(items: T[] = [], paginationMeta: PaginationMeta = new PaginationMeta()) {
    this.items = items
    this.metadata = paginationMeta
  }

  static fromResponse<T>(data: PaginatedInterface<T>, construct: { new(obj: unknown): T; }): Paginated<T> {
    const items = data.items.map((item) => new construct(item))
    return new this(items, PaginationMeta.fromResponse(data.metadata))
  }
}
